import { SimpleTable } from '@core/components/Table';
import { TableActionButton, TableActionContainer } from '@core/components/TableAction';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { downloadFile } from '@core/util/downloadUtils';
import { DataBR } from '@format/DATA';
import { Grid } from '@material-ui/core';
import { Cancel, Edit, Refresh } from '@material-ui/icons';
import FaXmlFileIcon from 'app/assets/icon/FaXmlFileIcon';
import { InfoButton } from 'app/main/faturamento/kanban/components/InfoButton';
import { confirmarAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import notaDevolucaoApi from 'app/services/api/notaDevolucaoApi';
import notaFiscalApi from 'app/services/api/notaFiscalApi';
import notaRemessaApi from 'app/services/api/notaRemessaApi';
import { relatorioApi } from 'app/services/api/relatorioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { visualizarRelatorioV2 } from 'app/utils/enviromentUtil';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useContext, useEffect } from 'react';
import { FaExclamationCircle, FaFilePdf } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { NotaFiscalContext } from '../NotaFiscalContext';
import NotaFiscalFab from './NotaFiscalFab';
import { notaFiscalStyles } from './styles';

const NOTA_FISCAL = 'Nota fiscal';

const NotaFiscalTable = ({ onSelection, fetchData, onTour }) => {
  const [notasFiscais] = useContext(NotaFiscalContext).notasFiscais;
  const [totalElements] = useContext(NotaFiscalContext).totalElements;
  const [, setPage] = useContext(NotaFiscalContext).page;
  const [, setSize] = useContext(NotaFiscalContext).size;
  const [, setSort] = useContext(NotaFiscalContext).sort;
  const [search] = useContext(NotaFiscalContext).search;
  const [filtroAvancado] = useContext(NotaFiscalContext).filtroAvancado;
  const [loading, setLoading] = useContext(NotaFiscalContext).loading;
  const [selecao] = useContext(NotaFiscalContext).selecao;

  const [, setModalErrosFaturamento] = useContext(GlobalContext).modalErrosFaturamento;
  const [, setPendencias] = useContext(GlobalContext).pendencias;
  const [, setModalPendenciasFaturamento] = useContext(GlobalContext).modalPendenciasFaturamento;
  const [, setErrosEmissao] = useContext(GlobalContext).errosEmissao;
  const [, setErrosCancelamento] = useContext(GlobalContext).errosCancelamento;
  const [, setEmpresa] = useContext(GlobalContext).empresa;
  const [, setModal] = useContext(NotaFiscalContext).modal;
  const [, setNotaDevolucao] = useContext(NotaFiscalContext).notaDevolucao;
  const [, setNotaRemessa] = useContext(NotaFiscalContext).notaRemessa;
  const [, setAtualizarGrid] = useContext(NotaFiscalContext).atualizarGrid;
  const [tipoSelecao, setTipoSelecao] = useContext(NotaFiscalContext).tipoSelecao;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useReduxLoading(loading);

  const styles = notaFiscalStyles();

  useEffect(() => {
    async function buscarEmpresa() {
      const response = await empresaApi.buscar(getEmpresaContexto());
      setEmpresa(response.data);
    }

    buscarEmpresa();
  }, [setEmpresa]);

  const handleVisualizarErrosFaturamento = (erros) => {
    eventReactGA(NOTA_FISCAL, 'Visualizar erros de faturamento');
    setErrosCancelamento([]);
    setErrosEmissao(erros);
    setModalErrosFaturamento('modalErrosFaturamento');
  };

  const handleVisualizarErrosCancelamento = (erros) => {
    eventReactGA(NOTA_FISCAL, 'Visualizar erros de cancelamento');
    setErrosEmissao([]);
    setErrosCancelamento(erros);
    setModalErrosFaturamento('modalErrosFaturamento');
  };

  const getTipo = (notaFiscal) => {
    const tipo = notaFiscal?.tipoNota;
    const origem = notaFiscal?.origem;
    if (tipo === 'VENDA') return 'Venda';
    if (tipo === 'CONTRATO') {
      if (origem && origem === 'VENDA_CONTRATO') return 'Venda e contrato';
      return 'Contrato';
    }
    if (tipo === 'VENDA_A_ORDEM') return 'Venda à ordem';
    if (tipo === 'VENDA_ENTREGA_FUTURA') return 'Venda de entrega futura';
    if (tipo === 'NOTA_REMESSA') return 'Nota de remessa';
    if (tipo === 'NOTA_DEVOLUCAO') return 'Nota de devolução';
  };

  const getSituacaoTag = (situacao, notafiscal) => {
    if (situacao === 'EM_FATURAMENTO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagEmFaturamento}`}>Em faturamento</div>
          </Grid>
        </Grid>
      );
    }

    if (situacao === 'EM_EMISSAO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagEmFaturamento}`}>Em emissão</div>
          </Grid>
        </Grid>
      );
    }

    if (situacao === 'EMITIDA') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagFaturado}`}>Emitida</div>
          </Grid>
          {notafiscal?.errosCancelamentos && notafiscal?.errosCancelamentos.length > 0 ? (
            <Grid item xs={2}>
              <InfoButton
                title="Visualizar erros de cancelamento"
                icon="cancel"
                onClick={() => handleVisualizarErrosCancelamento(notafiscal?.errosCancelamentos)}
              />
            </Grid>
          ) : null}
        </Grid>
      );
    }

    if (situacao === 'FATURADO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagFaturado}`}>Faturado</div>
          </Grid>

          {notafiscal?.errosCancelamentos && notafiscal?.errosCancelamentos.length > 0 ? (
            <Grid item xs={2}>
              <InfoButton
                title="Visualizar erros de cancelamento"
                icon="cancel"
                onClick={() => handleVisualizarErrosCancelamento(notafiscal?.errosCancelamentos)}
              />
            </Grid>
          ) : null}
        </Grid>
      );
    }

    if (situacao === 'CANCELADO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagCancelado}`}>Cancelado</div>
          </Grid>
        </Grid>
      );
    }

    if (situacao === 'EM_CANCELAMENTO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagEmCancelamento}`}>Em cancelamento</div>
          </Grid>
        </Grid>
      );
    }

    if (situacao === 'ERRO_TRANSMISSAO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={`${styles.tag} ${styles.tagErroTransmissao}`}>Erro de transmissão</div>
          </Grid>

          {notafiscal?.errosFaturamentos && notafiscal?.errosFaturamentos.length > 0 ? (
            <>
              <Grid item xs={2}>
                <InfoButton
                  style
                  title="Visualizar erros de transmissão"
                  icon="errorEmissao"
                  onClick={() => handleVisualizarErrosFaturamento(notafiscal?.errosFaturamentos)}
                />
              </Grid>
            </>
          ) : null}
        </Grid>
      );
    }

    if (situacao === 'ERRO_DE_CANCELAMENTO') {
      return (
        <Grid container>
          <Grid item xs={10}>
            <div className={styles.headerErroCancelamento}>
              <div className={`${styles.tag} ${styles.tagFaturado}`}>Faturado</div>
              <FaExclamationCircle color="#e88e18" size={16} />
            </div>
          </Grid>
        </Grid>
      );
    }
  };

  const handleExportarXML = async (notaId) => {
    setLoading(true);

    const params = {
      ids: [notaId],
    };

    delete params.page;
    delete params.size;
    delete params.sort;

    eventReactGA(NOTA_FISCAL, 'Exportar nota fiscal individual em XML');

    const response = await notaFiscalApi.exportarNotaFiscalIndividualXML(params);

    downloadFile(response.data.arquivo, `${response.data.nome}`);

    setLoading(false);
  };

  const handleVisualizarPDF = async (notaFiscalId) => {
    eventReactGA(NOTA_FISCAL, 'Visualizar PDF');

    const response = await relatorioApi().salvarFiltroVisualizarFaturamento(notaFiscalId);
    visualizarRelatorioV2(response.data);
  };

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const alertCancelamentoNf = async (faturamentoId, tipo) => {
    setLoading(true);
    let response = null;
    try {
      if (tipo === 'NOTA_DEVOLUCAO') {
        eventReactGA(NOTA_FISCAL, 'Cancelar nota fiscal de devolução');
        response = await notaDevolucaoApi.cancelar(faturamentoId);
      } else if (tipo === 'NOTA_REMESSA') {
        eventReactGA(NOTA_FISCAL, 'Cancelar nota fiscal de remessa');
        response = await notaRemessaApi.cancelar(faturamentoId);
      }
      if (response?.status === 200) {
        showSuccess('Cancelamento de nota fiscal em processamento.');
        setAtualizarGrid(true);
        setLoading(false);
        if (tipo === 'NOTA_DEVOLUCAO') {
          await notaDevolucaoApi.atualizarHomol('CANCELADO');
        } else if (tipo === 'NOTA_REMESSA') {
          await notaRemessaApi.atualizarHomol('CANCELADO');
        }
      }
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelarNF = async (faturamentoId, tipo) => {
    const title = 'Tem certeza que deseja solicitar cancelamento da Nota Fiscal?';
    confirmarAlert({
      opcoes: {
        title,
      },
      confirmar: async () => alertCancelamentoNf(faturamentoId, tipo),
    });
  };

  const handleEditNF = async (faturamentoId, tipo) => {
    if (tipo === 'NOTA_DEVOLUCAO') {
      const response = await notaDevolucaoApi.buscar(faturamentoId);
      if (response.data) {
        setNotaDevolucao(response.data);
        setModal('notaDevolucao');
      }
    } else if (tipo === 'NOTA_REMESSA') {
      const response = await notaRemessaApi.buscar(faturamentoId);
      if (response.data) {
        setNotaRemessa(response.data);
        setModal('notaRemessa');
      }
    }
  };

  const reenviarDevolucao = (uuid) => {
    const reenviar = async (uuid) => {
      try {
        eventReactGA(NOTA_FISCAL, 'Reenviar nota fiscal de devolução');
        const resp = await notaDevolucaoApi.reenviar(uuid);
        if (resp?.status === 200) {
          showSuccess('Nota de devolução salva com sucesso.');
          setAtualizarGrid(true);
          setLoading(false);
        }
      } catch (err) {
        apiUtils.handleApiError(err);
        setLoading(false);
      } finally {
        await notaDevolucaoApi.atualizarHomol('CONCLUIDO');
      }
    };

    confirmarAlert({
      mensagem:
        'Tem certeza que deseja emitir a nota fiscal de devolução? Ao concordar, ela será emitida imediatamente. ',
      confirmar: async () => {
        try {
          setLoading(true);

          const resp = await notaDevolucaoApi.buscar(uuid);

          if (resp?.data) {
            notaDevolucaoApi.validarPendenciasReenvio(resp?.data.id).then((response) => {
              if (response.data && response.data.length > 0) {
                setPendencias(response.data);
                setModalPendenciasFaturamento('modalPendenciasFaturamento');
                setLoading(false);
              } else {
                reenviar(uuid);
              }
            });
          }
        } catch (err) {
          apiUtils.handleApiError(err);
        }
      },
    });
  };

  const reenviarRemessa = (uuid) => {
    const reenviar = async (uuid) => {
      try {
        eventReactGA(NOTA_FISCAL, 'Reenviar nota fiscal de remessa');
        const resp = await notaRemessaApi.reenviar(uuid);
        if (resp?.status === 200) {
          showSuccess('Nota de remessa salva com sucesso.');
          setAtualizarGrid(true);
          setLoading(false);
        }
      } catch (err) {
        apiUtils.handleApiError(err);
        setLoading(false);
      } finally {
        await notaRemessaApi.atualizarHomol('CONCLUIDO');
      }
    };

    confirmarAlert({
      mensagem:
        'Tem certeza que deseja emitir a nota fiscal de remessa? Ao concordar, ela será emitida imediatamente. ',
      confirmar: async () => {
        try {
          setLoading(true);

          const resp = await notaRemessaApi.buscar(uuid);

          if (resp?.data) {
            notaRemessaApi.validarPendenciasReenvio(resp?.data.id).then((response) => {
              if (response.data && response.data.length > 0) {
                setPendencias(response.data);
                setModalPendenciasFaturamento('modalPendenciasFaturamento');
                setLoading(false);
              } else {
                reenviar(uuid);
              }
            });
          }
        } catch (err) {
          apiUtils.handleApiError(err);
        }
      },
    });
  };

  const handleReenviarNF = async (uuid, tipo) => {
    if (tipo === 'NOTA_DEVOLUCAO') {
      reenviarDevolucao(uuid);
    } else if (tipo === 'NOTA_REMESSA') {
      reenviarRemessa(uuid);
    }
  };

  const exibirBotoesAcao = (nota) => {
    return (
      <TableActionContainer>
        {(nota.situacao === 'EM_CANCELAMENTO' ||
          nota.situacao === 'CANCELADO' ||
          nota.situacao === 'FATURADO' ||
          nota.situacao === 'EMITIDA') && (
          <TableActionButton
            title="Exportar nota fiscal em XML"
            icon={<FaXmlFileIcon size={12} style={{ fontSize: '0.5em' }} />}
            onClick={() => handleExportarXML(nota.id)}
          />
        )}
        {(nota.situacao === 'EM_CANCELAMENTO' ||
          nota.situacao === 'CANCELADO' ||
          nota.situacao === 'FATURADO' ||
          nota.situacao === 'EMITIDA') && (
          <TableActionButton
            title="Visualizar NF"
            icon={<FaFilePdf size={12} style={{ fontSize: '0.5em' }} />}
            onClick={() => handleVisualizarPDF(nota.notaFiscalId)}
          />
        )}
        {nota.situacao === 'ERRO_TRANSMISSAO' &&
          (nota.tipoNota === 'NOTA_DEVOLUCAO' || nota.tipoNota === 'NOTA_REMESSA') && (
            <>
              <TableActionButton
                title="Editar NF"
                icon={<Edit size={10} style={{ fontSize: '0.5em' }} />}
                onClick={() => handleEditNF(nota.id, nota.tipoNota)}
              />
              <TableActionButton
                title="Reenviar NF"
                icon={<Refresh size={10} style={{ fontSize: '0.5em' }} />}
                onClick={() => handleReenviarNF(nota.id, nota.tipoNota)}
              />
            </>
          )}
        {nota.situacao === 'EMITIDA' && (nota.tipoNota === 'NOTA_DEVOLUCAO' || nota.tipoNota === 'NOTA_REMESSA') && (
          <TableActionButton
            title="Cancelar NF"
            icon={<Cancel size={10} style={{ fontSize: '0.5em' }} />}
            onClick={() => handleCancelarNF(nota.id, nota.tipoNota)}
          />
        )}
      </TableActionContainer>
    );
  };

  const columns = [
    {
      name: 'serienNfnumeroNf',
      title: 'Série/NF',
      align: 'left',
      getCellValue: (notaFiscal) => {
        const serie = notaFiscal?.serieNf ? `${notaFiscal?.serieNf} - ` : '';
        const numero = notaFiscal?.numeroNf ? notaFiscal?.numeroNf : '';

        if (serie === '' && numero === '') {
          return '-';
        }

        return `${serie}${numero}`;
      },
      sortingEnabled: false,
    },
    {
      name: 'dataEmissaoNf',
      title: 'Data de emissão',
      align: 'center',
      getCellValue: (notaFiscal) => notaFiscal?.dataEmissaoNf && DataBR(notaFiscal?.dataEmissaoNf),
      sortingEnabled: true,
    },
    {
      name: 'nomeCliente',
      title: 'Cliente',
      align: 'left',
      getCellValue: (notaFiscal) => notaFiscal?.nomeCliente && notaFiscal?.nomeCliente,
      sortingEnabled: true,
    },
    {
      name: 'tipoNota',
      title: 'Tipo',
      align: 'left',
      sortingEnabled: true,
      getCellValue: (notaFiscal) => notaFiscal?.tipoNota && notaFiscal?.origem && getTipo(notaFiscal),
    },
    {
      name: 'valor',
      title: 'Valor (R$)',
      align: 'right',
      getCellValue: (notaFiscal) => notaFiscal?.valor && getCurrency(notaFiscal?.valor),
      sortingEnabled: true,
    },
    {
      name: 'situacao',
      title: 'Situação',
      align: 'center',
      hideTooltip: true,
      sortingEnabled: true,
      getCellValue: (notaFiscal) => notaFiscal?.situacao && getSituacaoTag(notaFiscal?.situacao, notaFiscal),
    },

    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (notaFiscal) => exibirBotoesAcao(notaFiscal),
    },
  ];

  const footerTable = (
    <div>
      {/*  <div style={{ padding: '12px 0 0 24px' }}>Valor total das Notas Fiscais (R$): {getNotasFiscaisTotal()} </div> */}
    </div>
  );

  return (
    <>
      <SimpleTable
        getRowId={(row) => row}
        fetchOnCreate={false}
        defaultSorting={[{ columnName: 'dataEmissaoNf', direction: 'desc' }]}
        columns={columns}
        rows={notasFiscais}
        selection={selecao}
        loading={loading}
        totalCount={totalElements}
        fetchData={fetchData}
        onSelectionChange={onSelection}
        onCurrentPageChange={setPage}
        onPageSizeChange={setSize}
        onSortingChange={setSort}
        footerTable={footerTable}
        selectionType={tipoSelecao}
        onSelectionTypeChange={(params) => {
          setTipoSelecao(params);
        }}
        searchBy={search}
        params={filtroAvancado}
        contemFiltroAvancado
      />
      <NotaFiscalFab />
    </>
  );
};

export default NotaFiscalTable;
